export const LEAD_LIST_SOURCE = {
  LINKEDIN_SEARCH_RESULT: "1",
  SALES_NAVIGATOR_SEARCH_RESULT: "2",
  SALES_NAVIGATOR_LIST: "leads-list",
  RECRUITER_SEARCH_RESULT: "recruiter",
  RECRUITER_PIPELINE: "recruiter-pipeline",
  LINKEDIN_POST: "post-engagement",
  IMPORT: "import",
}

export const PROSPECT_SOURCE_TYPE = {
  SALES_NAVIGATOR: "SALES_NAVIGATOR",
  RECRUITER: "RECRUITER",
  POST_ENGAGEMENT: "POST_ENGAGEMENT",
  BASIC: "BASIC",
  LEADS_LIST: "LEADS_LIST",
  CSV: "CSV",
  WEB_HOOK: "WEB_HOOK",
  TALENT_LIST: "TALENT_LIST",
  MANUALLY_ADDED: "MANUALLY_ADDED",
}
